<div class="container-fluid content-padded">
  <div class="row">
    <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
      <div class="blog-container" *ngIf="!isLoadingBlog">
        <h1 class="title">{{blog.name}}
          <br>
          <span class="publish-date">{{blog.publishDate | date: 'MM/dd/yyyy'}}</span>
        </h1>
        <img class="blog-img" [src]="getImgUrl(blog.blogId)" (error)="imgError($event)" alt="">
        <div class="content" [innerHtml]="blog.htmlContent | safeHtml"></div>
      </div>
      <div *ngIf="isLoadingBlog">
        <span class="loading title"></span>
        <ng-template ngFor [ngForOf]="numbers">
          <span class="loading content"></span>
        </ng-template>
      </div>
    </div>
    <!-- Other Information -->
    <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 thumbnails-container thumbnails-side">
        <app-thumb-learn-about-io [routerLink]="['/learn-about-io']"></app-thumb-learn-about-io>
        <app-thumb-living-with-cancer></app-thumb-living-with-cancer>
        <app-thumb-join-today></app-thumb-join-today>
    </div>
    <!-- Other Information -->
  </div>
</div>
